export default __webpack_public_path__ + "static/media/Punto_06_Chiesa_e_Convento_dei_Domenicani_FRA_Def.67072b5c.aac";